import { Fragment } from 'react';
import { Button, BUTTON } from 'components/common/Button/Button';
import styles from './styles.scss';

export default function Footer({handleNext, handleCancel, isStep, handleSaveAsDraft, handleSubmit, handlePrevious}) {
    return (
        <Fragment>
            {
                isStep === 'one' && (
                    <StepOne onCancel={handleCancel} onNext={handleNext}/>
                )
            }
            {
                isStep === 'two' && (
                    <StepTwo onCancel={handleCancel} onPrevious={handlePrevious} onDraft={handleSaveAsDraft} handleSubmit={handleSubmit} />
                )
            }
        </Fragment>
    );
}

function StepOne({onCancel, onNext}) {
    return (
        <div className={styles.Footer}>
            <Button
                bgcolor={BUTTON.BGCOLOR.WHITE}
                type={BUTTON.SIZE.SECONDARY}
                color={BUTTON.COLOR.BLACK}
                outline={BUTTON.OUTCOLOR.LIGHTGREY}
                onClick={onCancel}
            >
                Cancel
            </Button>

            <Button
                type={BUTTON.SIZE.SECONDARY}
                bgcolor={BUTTON.BGCOLOR.ORANGE}
                color={BUTTON.COLOR.WHITE}
                onClick={onNext}
            >
                Next
            </Button>
        </div>
    );
}

function StepTwo({onCancel, handleSubmit, onPrevious, onDraft}) {
    return (
        <div className={styles.Footer}>
            <div className={styles.FooterInnerItem}>
                <Button
                    bgcolor={BUTTON.BGCOLOR.WHITE}
                    type={BUTTON.SIZE.SECONDARY}
                    color={BUTTON.COLOR.BLACK}
                    outline={BUTTON.OUTCOLOR.LIGHTGREY}
                    onClick={onCancel}
                >
                    Cancel
                </Button>

                <Button
                    bgcolor={BUTTON.BGCOLOR.WHITE}
                    type={BUTTON.SIZE.SECONDARY}
                    color={BUTTON.COLOR.BLACK}
                    outline={BUTTON.OUTCOLOR.LIGHTGREY}
                    onClick={onDraft}
                >
                    Save Draft
                </Button>
            </div>

            <div className={styles.FooterInnerItem}>
                <Button
                    bgcolor={BUTTON.BGCOLOR.WHITE}
                    type={BUTTON.SIZE.SECONDARY}
                    color={BUTTON.COLOR.BLACK}
                    outline={BUTTON.OUTCOLOR.LIGHTGREY}
                    onClick={onPrevious}
                >
                    Previous
                </Button>

                <Button
                    type={BUTTON.SIZE.SECONDARY}
                    bgcolor={BUTTON.BGCOLOR.ORANGE}
                    color={BUTTON.COLOR.WHITE}
                    onClick={handleSubmit}
                >
                    Finish
                </Button>
            </div>
        </div>
    );
}